import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class ProductLinkedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#update);
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #update = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const updated = detail.html.querySelector(
          `product-linked-products[data-block-id="${CSS.escape(this.dataset.blockId ?? '')}"]`
        );
        if (updated) morph(this, updated);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-linked-products] Update failed:', error);
      });
  };
}

if (!customElements.get('product-linked-products')) {
  customElements.define('product-linked-products', ProductLinkedProducts);
}
